import { getApiB2bApplicationByIdGetUnitData } from '/api/sdk.gen';

import type { AppDispatch } from '/business/shared/state/store';
import ValidationError from '/shared/errors/ValidationError';
import normaliseError, { toNormaliseErrorInput } from '/shared/functions/normaliseError';

const getUnitData =
  (id: number | string | null = null) =>
  async (dispatch: AppDispatch) => {
    try {
      if (!id) {
        throw new Error('No data sent to get unit data');
      }
      dispatch({ type: 'GET_UNIT_DATA_STARTED', applicationId: id, timestamp: Date.now() });
      await new Promise((resolve) => setTimeout(resolve, 1000));
      const { data: unitData } = await getApiB2bApplicationByIdGetUnitData({ path: { id: String(id) } });
      if (!unitData) {
        throw new Error('No unit data returned');
      }
      const { units } = unitData;
      dispatch({
        type: 'GET_UNIT_DATA_FULFILLED',
        units,
        applicationId: id,
      });
      return unitData;
    } catch (error) {
      if (error instanceof ValidationError) {
        dispatch({ type: 'GET_UNIT_DATA_REJECTED', applicationId: id, error });
      } else {
        dispatch({
          type: 'GET_UNIT_DATA_REJECTED',
          applicationId: id,
          error: normaliseError(toNormaliseErrorInput(error), 'GET_UNIT_DATA_FULFILLED'),
        });
      }
      throw error;
    }
  };

export default getUnitData;
